import { InputWithLabel } from '@adotel/components'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import { memo } from 'react'

import {
  buildFeatureSet,
  getCredentials,
  hasRequiredFeatures
} from '../../cache/auth'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import accommodationPagesRoleManagement from '../../staticRoleManagement/accommodationsRoleManagement'
import useStyles from './styles/AccommodationsHeader.styles'

interface AccommodationsListHeaderProps {
  inputValue: string | undefined
  setinputVal: (val: string) => void
}
const AccommodationsListHeader: React.FC<AccommodationsListHeaderProps> = ({
  inputValue,
  setinputVal
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  return (
    <>
      <div className={classes.header}>
        <Typography variant="h3" gutterBottom>
          {isSmallScreen
            ? getTranslate('Accommodations')
            : getTranslate('Accommodations List')}
        </Typography>
        {hasRequiredFeatures(
          accommodationPagesRoleManagement.find(
            (item) => item.route === '/accommodations'
          )?.sections?.ADD_ACCOMMODATION.requiredFeatures,
          featureSet
        ) && (
          <Button
            data-cy="addAccommodations"
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            component={LocalizedLink}
            to="/accommodations/create">
            {isSmallScreen
              ? getTranslate('Add')
              : getTranslate('Add Accommodation')}
          </Button>
        )}
      </div>
      <div className={classes.root}>
        <InputWithLabel
          data-cy="SearchNameOrProperty"
          placeholder={getTranslate('Search by name or property code')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          className={classes.searchInput}
          value={inputValue}
          onChange={(event) => {
            setinputVal(
              convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
            )
          }}
        />
      </div>
    </>
  )
}

export default memo(AccommodationsListHeader)
